import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  editBooking: {
    justifyContent: 'space-between',
  },
}));

export default useStyles;
